import { ContextTag, Css, IconButton, IconKey, Tokens, useTestIds } from "@homebound/beam";
import { ReactNode } from "react";

type TakeoffsSidePanelProps = {
  /** Without a tag, e.g. Bulk Edit, the title shares the close button's row */
  tag?: { icon: IconKey; text: string };
  title: string;
  onClose: VoidFunction;
  footer: { start?: ReactNode; end: ReactNode };
  children: ReactNode;
};

// TODO: Beam gap (DS-419): swap for Beam's `RightPanePanel` once Beam is bumped to v4.39.0+ for its tag slot
// (homebound-team/beam#1532) and its isDirty guard lands (homebound-team/beam#1533)
/** The Takeoffs tab's right pane chrome. */
export function TakeoffsSidePanel(props: TakeoffsSidePanelProps) {
  const { tag, title, onClose, footer, children } = props;
  const tid = useTestIds(props, "takeoffsSidePanel");
  const heading = (
    <h2 css={Css.xl.$} {...tid.title}>
      {title}
    </h2>
  );
  return (
    <div css={Css.df.fdc.h100.$} {...tid}>
      <div css={Css.df.fdc.gap1.p2.bb.bc(Tokens.SurfaceSeparator).fs0.$}>
        <div css={Css.df.aic.jcsb.$}>
          {tag ? <ContextTag icon={tag.icon} text={tag.text} /> : heading}
          {/* Moves focus off the control that opened the pane */}
          <IconButton icon="x" label="Close" autoFocus onClick={onClose} {...tid.close} />
        </div>
        {tag && heading}
      </div>
      <div css={Css.fg1.mh0.oya.p2.$} {...tid.body}>
        {children}
      </div>
      <div css={Css.df.aic.jcsb.gap1.p2.bt.bc(Tokens.SurfaceSeparator).fs0.$} {...tid.footer}>
        <div>{footer.start}</div>
        <div css={Css.df.gap1.$}>{footer.end}</div>
      </div>
    </div>
  );
}
